import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ManageKirsActions } from './manage-kirs.actions';
import { ManageKirsService } from '../../service/manage-kirs.service';


@Injectable()
export class ManageKirsEffects {
  getKirs$ = createEffect(
    (rs: ManageKirsService = inject(ManageKirsService)) => {
      return this.actions$.pipe(

        ofType(ManageKirsActions.loadManageKirs),
        mergeMap(({ campaignId, parameters }) =>
          rs.getKirs(campaignId, parameters).pipe(
            map((kirs) => {
              return ManageKirsActions.loadManageKirsSuccess({
                kirs
              });
            }),
            catchError((error) => of(ManageKirsActions.loadManageKirsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  getAllKirs$ = createEffect(
    (rs: ManageKirsService = inject(ManageKirsService)) => {
      return this.actions$.pipe(

        ofType(ManageKirsActions.loadAllManageKirs),
        mergeMap(({ campaignId, parameters }) =>
          rs.getKirs(campaignId, parameters).pipe(
            map((kirs) => {
              return ManageKirsActions.loadAllManageKirsSuccess({
                kirs
              });
            }),
            catchError((error) => of(ManageKirsActions.loadAllManageKirsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );



  createOrUpdateKirs$ = createEffect(
    (rs: ManageKirsService = inject(ManageKirsService)) => {
      return this.actions$.pipe(
        ofType(ManageKirsActions.createOrUpdateKirs),
        concatMap(({ campaignId, input, parameters }) =>
          rs.createOrUpdateKirs(campaignId, input).pipe(
            mergeMap((createOrUpdate) => [
              ManageKirsActions.createOrUpdateKirsSuccess({ createOrUpdate }),
              ManageKirsActions.loadAllManageKirs({
                campaignId, parameters: {
                  page: 0,
                  order: {
                    sortField: null,
                    sortDirection: "ASC"
                  },
                  search: null,
                  filters: {},
                  rows: 1000000
                }
              }),
              ManageKirsActions.loadManageKirs({
                campaignId, parameters
              })
            ]
            ),
            catchError((error) => of(ManageKirsActions.createOrUpdateKirsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  deleteKirs$ = createEffect(
    (rs: ManageKirsService = inject(ManageKirsService)) => {
      return this.actions$.pipe(
        ofType(ManageKirsActions.deleteKirs),
        concatMap(({ campaignId, id }) =>
          rs.deleteKirs(campaignId, id).pipe(
            mergeMap((deleteKirs) => [
              ManageKirsActions.deleteKirsSuccess({ deleteKirs, id }),
              ManageKirsActions.loadAllManageKirs({
                campaignId, parameters: {
                  page: 0,
                  order: {
                    sortField: null,
                    sortDirection: "ASC"
                  },
                  search: null,
                  filters: {},
                  rows: 1000000
                }
              })
            ]
            ),
            catchError((error) => of(ManageKirsActions.deleteKirsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
